// API constants

// load config from public/config.json from server to make this environment dependent.

function loadConfigFromServer() {
  const xmlhttp = new XMLHttpRequest();

  xmlhttp.open("GET", window.location.origin + "/config.json", false);
  xmlhttp.send();

  if (xmlhttp.status === 200 && xmlhttp.readyState === 4) {
    return JSON.parse(xmlhttp.responseText);
  } else {
    // TODO Throw exception
    return null;
  }
}

const json = loadConfigFromServer();

let constants = {
  ...json,
  IS_PROD: json.IS_PROD === "true",
};

if (process.env.REACT_APP_USE_LOCAL_ENV === "true") {
  constants = {
    IS_PROD: process.env.REACT_APP_IS_PROD === "true" || false,

    API_SERVER:
      process.env.REACT_APP_API_SERVER || "http://localhost:4050/api/",
    CENTRAL_API_SERVER:
      process.env.REACT_APP_API_SERVER || "http://localhost:8000/api/v1/",
    ROOT: process.env.REACT_APP_ROOT || "https://qaprovider-portal.nmm.cc",
    STAGING_API_SERVER:
      process.env.REACT_APP_STAGING_API_SERVER ||
      "https://provider-proxy-test.nmm.cc/api/",
    PORTAL_MANAGER_API_SERVER:
      process.env.REACT_APP_PORTAL_MANAGER_API_SERVER ||
      "http://localhost:5170/api/",

    AHC_API_SERVER:
      process.env.REACT_APP_AHC_API_SERVER ||
      "https://qaprovider-services-ahc.nmm.cc/api/",
    AHC_ROOT:
      process.env.REACT_APP_AHC_ROOT ||
      "https://qaprovider-services-ahc.nmm.cc",
    CFC_API_SERVER:
      process.env.REACT_APP_CFC_API_SERVER ||
      "https://qaprovider-services-cfc.nmm.cc/api/",
    CFC_ROOT:
      process.env.REACT_APP_AHC_ROOT ||
      "https://qaprovider-services-cfc.nmm.cc",
    ALPHA_API_SERVER:
      process.env.REACT_APP_ALPHA_API_SERVER ||
      "https://qaprovider-services-alpha.nmm.cc/api/",
    ALPHA_ROOT:
      process.env.REACT_APP_AHC_ROOT ||
      "https://qaprovider-services-alpha.nmm.cc",
    LSMA_API_SERVER:
      process.env.REACT_APP_LSMA_API_SERVER ||
      "https://qaprovider-services-lsma.nmm.cc/api/",
    LSMA_ROOT:
      process.env.REACT_APP_AHC_ROOT ||
      "https://qaprovider-services-lsma.nmm.cc",
    BAIPA_API_SERVER:
      process.env.REACT_APP_BA_API_SERVER ||
      "https://qaprovider-services-ba.nmm.cc/api/",
    BAIPA_ROOT:
      process.env.REACT_APP_AHC_ROOT || "https://qaprovider-services-ba.nmm.cc",
    JADE_API_SERVER:
      process.env.REACT_APP_JADE_API_SERVER ||
      "https://qaprovider-services-jade.nmm.cc/api/",
    JADE_ROOT:
      process.env.REACT_APP_JADE_ROOT ||
      "https://qaprovider-services-jade.nmm.cc",
    AAMG_API_SERVER:
      process.env.REACT_APP_AAMG_API_SERVER ||
      "https://qaprovider-services-aamg.nmm.cc/api/",
    AAMG_ROOT:
      process.env.REACT_APP_AAMG_ROOT ||
      "https://qaprovider-services-aamg.nmm.cc",
    CVMG_API_SERVER:
      process.env.REACT_APP_CVMG_API_SERVER ||
      "https://qaprovider-services-cvmg.nmm.cc/api/",
    CVMG_ROOT:
      process.env.REACT_APP_CVMG_ROOT ||
      "https://qaprovider-services-cvmg.nmm.cc",
    AMTX_API_SERVER:
      process.env.REACT_APP_AMTX_API_SERVER ||
      "https://qaprovider-services-amtx.nmm.cc/api/",
    AMTX_ROOT:
      process.env.REACT_APP_AMTX_ROOT ||
      "https://qaprovider-services-amtx.nmm.cc",
    AMNV_API_SERVER:
      process.env.REACT_APP_AMNV_API_SERVER ||
      "https://qaprovider-services-amnv.nmm.cc/api/",
    AMNV_ROOT:
      process.env.REACT_APP_AMNV_ROOT ||
      "https://qaprovider-services-amnv.nmm.cc",
    ACPAZ_API_SERVER:
      process.env.REACT_APP_ACPAZ_API_SERVER ||
      "https://nmm-qa-consumption-providerportal-6.azure-api.net/acpaz/v1/api/",
    ACPAZ_ROOT:
      process.env.REACT_APP_ACPAZ_ROOT ||
      "https://nmm-qa-consumption-providerportal-6.azure-api.net/acpaz/v1",
    MDPTN_API_SERVER:
      process.env.REACT_APP_MDPTN_API_SERVER ||
      "https://nmm-qa-consumption-providerportal-6.azure-api.net/mdptn/v1/api/",
    MDPTN_ROOT:
      process.env.REACT_APP_MDPTN_ROOT ||
      "https://nmm-qa-consumption-providerportal-6.azure-api.net/mdptn/v1",
    BACP_API_SERVER:
      process.env.REACT_APP_BACP_API_SERVER ||
      "https://nmm-qa-consumption-providerportal-6.azure-api.net/bacp/v1/api/",
    BACP_ROOT:
      process.env.REACT_APP_BACP_ROOT ||
      "https://nmm-qa-consumption-providerportal-6.azure-api.net/bacp/v1",

    UMS_SERVER: process.env.REACT_APP_UMS_SERVER || "fakeUms://",
    UMS_CLIENT_ID: process.env.REACT_APP_UMS_CLIENT_ID || "fakeClientId",
    UMS_CLIENT_SECRET:
      process.env.REACT_APP_UMS_CLIENT_SECRET || "fakeClientSecret",

    BUILD_NUMBER: process.env.REACT_APP_BUILD_NUMBER || "Local",
    AWV_ENABLE_IPA: process.env.AWV_ENABLE_IPA || "ALL",
    AWV_ENABLE_USER: process.env.AWV_ENABLE_USER || "ALL",
    PBI_ENABLE_IPA: process.env.PBI_ENABLE_IPA || "ALL",
    PBI_ENABLE_USER: process.env.PBI_ENABLE_USER || "ALL",
    DEFAULT_PAGINATION_PER_PAGE: 50,
    ICD_VERSION: 10,
    LAST_DATE_FOR_MEASURE_UPDATE:
      process.env.LAST_DATE_FOR_MEASURE_UPDATE || "03-31",
    LAST_DATE_FOR_CLOSING_GAPS:
      process.env.LAST_DATE_FOR_CLOSING_GAPS || "03-31",
    RAF_SCORE_MONTH: process.env.RAF_SCORE_MONTH || "May",
    LANAIR_SHIFT_NOTIFICATION_DATE:
      process.env.LANAIR_SHIFT_NOTIFICATION_DATE || "04-09-23",
    SHOW_LANAIR_SHIFT_MAINTENANCE_MESSAGE:
      process.env.SHOW_LANAIR_SHIFT_MAINTENANCE_MESSAGE || "true",
    DISABLING_IPA_NAME: process.env.DISABLING_IPA_NAME || "LSMA",
    IPA_DISABLING_DATE_TIME:
      process.env.IPA_DISABLING_DATE_TIME || "09-01-23 17:00",
    IPA_DISABLING_MESSAGE:
      process.env.IPA_DISABLING_MESSAGE ||
      'Starting 09/01/2023, LSMA providers will need to use AlturaWeb Portal (<a href="https://connect.alturamso.com" target="_blank">connect.alturamso.com</a>). <br/> If you have any questions, please contact (888) 554-4562',

    PORTAL_URL: process.env.PORTAL_URL || "http://localhost:3000/login",
    B2C_PORTAL_URL:
      process.env.B2C_PORTAL_URL ||
      "https://qa-b2c-provider-portal.astranahealth.com/login",
    B2C_IPAS: process.env.B2C_IPAS || "NCPN, LSMA, AHISP, CCPP",
    B2C_Register_IPAS: process.env.B2C_Register_IPAS || "DEMO,AHISP,AMNV,CCPP,AMTX,BAIPA,AAMG,JADE,CFC,AHC,ACPAZ,BACP,MDPTN",
    B2C_TRANSITION_IPAS: process.env.B2C_TRANSITION_IPAS || "AAMG, JADE",
    HIDE_ACO: process.env.REACT_APP_HIDE_ACO || false,
    RESOURCE_ROOT: process.env.RESOURCE_ROOT || "https://vendor-portal.nmm.cc",
    APP_INSIGHTS_CONNECTION_STRING:
      process.env.APP_INSIGHTS_CONNECTION_STRING ||
      "InstrumentationKey=886b5950-d3c2-45ba-8706-a78ec74ad487;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/",
    PROV_RAF_TITLE: process.env.PROV_RAF_TITLE || "May 2023 RAF SCORE",
    CURRENT_RAF_TITLE: process.env.CURRENT_RAF_TITLE || "Nov 2023 RAF SCORE",
  };
}

export default constants;
